/*
 * @Author: ningbo.kang
 * @Date: 2019-12-21 14:54:09
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2023-06-26 15:08:47
 * @Description: 字段与组件对照关系表
 */
export default {
  formItem: 'wgFormItem',
  blank: 'wgBlank',
  cascader: 'wgCascader',
  list: 'wgList',
  tabs: 'wgTabs',
  table: 'wgTable',
  card: 'wgCard',
  grid: 'wgGrid',
  divider: 'wgDivider',
  fileupload: 'wgFileupload',
  input: 'wgInput',
  hidden: 'wgHidden',
  html: 'wgHtml',
  link: 'wgLink',
  number: 'wgNumber',
  textarea: 'wgTextarea',
  text: 'wgText',
  slider: 'wgSlider',
  switch: 'wgSwitch',
  radio: 'wgRadio',
  checkbox: 'wgCheckbox',
  select: 'wgSelect',
  rate: 'wgRate',
  date: 'wgDate',
  time: 'wgTime',
  treeSelect: 'wgTreeSelect',
  dialog: 'wgDialog',
  dateRange: 'wgDateRange',
  processSelect: 'wgProcessSelect',
  compute: 'wgCompute',
};
